module.exports = __webpack_public_path__ + "img/be-icon-menu-updated.bc5262cd.svg";